import { render } from "./RecurringOrderDetails.vue?vue&type=template&id=80e2d924&ts=true"
import script from "./RecurringOrderDetails.vue?vue&type=script&lang=ts"
export * from "./RecurringOrderDetails.vue?vue&type=script&lang=ts"

import "./RecurringOrderDetails.vue?vue&type=style&index=0&id=80e2d924&lang=scss"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__